import React from 'react';
import { StickyNav } from './components/StickyNav';
import { Hero } from './components/Hero';
import { OpeningHook, PainAmplification, PainLoopReveal, MechanismReveal, ProductIntro, ChaptersGrid, Testimonials, StrongClose } from './components/SalesSections';
import { BonusCards } from './components/BonusCards';
import { ValueTable } from './components/ValueTable';
import { UrgencyBanner } from './components/UrgencyBanner';
import { EditorialBlock } from './components/EditorialBlock';
import { GuaranteeCard } from './components/GuaranteeCard';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Layout';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-teal-400 selection:text-navy-800" data-id="element-0">
      <StickyNav data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <OpeningHook data-id="element-4" />
        <PainAmplification data-id="element-5" />
        <PainLoopReveal data-id="element-6" />
        <MechanismReveal data-id="element-7" />
        <ProductIntro data-id="element-8" />
        <ChaptersGrid data-id="element-9" />
        <Testimonials data-id="element-10" />
        <BonusCards data-id="element-11" />
        <ValueTable data-id="element-12" />
        <UrgencyBanner data-id="element-13" />
        <EditorialBlock data-id="element-14" />
        <StrongClose data-id="element-15" />
        <GuaranteeCard data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>

      <Footer data-id="element-18" />
      <RecentPurchaseToast data-id="element-19" />
    </div>;
}